import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
    return (
        <nav className="flex items-center gap-2 text-gray-600 text-sm">
          {items.map((item, index) => (
            <span key={index} className="flex gap-2 items-center">
              {index > 0 && (
                <span>&gt;</span>
              )}
              {item.to ? (
                <Link to={item.to} className="hover:underline">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'font-bold text-black' : ''}>{item.label}</span>
              )}
            </span>
          ))}
        </nav>
      );
    };
    
    export default Breadcrumb;